import React from "react";

const PageHeader = ({
  eyebrow,
  title,
  subtitle,
  role = "admin",
  gradient,
  accent,
  actions,
  children,
}) => {
  return (
    <header className="ph-band">
      {/* Subtle dark gradient background */}
      <div className="ph-band__bg" aria-hidden="true" />
      {/* Soft indigo glow orb — the only accent */}
      <div className="ph-band__orb" aria-hidden="true" />

      <div className="ph-band__inner">
        <div className="ph-band__left">
          {eyebrow && (
            <span className="ph-band__eyebrow">
              <span className="ph-band__eyebrow-dot" />
              {eyebrow}
            </span>
          )}
          {title && <h1 className="ph-band__title">{title}</h1>}
          {subtitle && <p className="ph-band__subtitle">{subtitle}</p>}
        </div>
        {(actions || children) && (
          <div className="ph-band__right">
            {actions && <div className="ph-band__cta">{actions}</div>}
            {children}
          </div>
        )}
      </div>

      {/* Bottom separator line */}
      <div className="ph-band__rule" aria-hidden="true" />
    </header>
  );
};

export default PageHeader;